import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TONES = {
  educator: 'bg-cs-blue-50 text-cs-blue-800 border-cs-blue-200',
  partner: 'bg-cs-purple-50 text-cs-purple-800 border-cs-purple-200',
  both: 'bg-cs-orange-50 text-cs-orange-800 border-cs-orange-200',
  untagged: 'bg-cs-yellow-50 text-cs-yellow-800 border-cs-yellow-300'
};

/**
 * A small pill for an audience (Educator, Partner, Both), a home slot such
 * as "Educator 1", or the Untagged indicator.
 */
AudienceChip.propTypes = {
  tone: PropTypes.oneOf(Object.keys(TONES)).isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default function AudienceChip(props) {
  const { tone, children, title } = props;
  return (
    <span
      title={title}
      className={classNames(
        'inline-flex items-center px-2 py-0.5 rounded-full border text-xs font-semibold whitespace-nowrap',
        TONES[tone]
      )}
    >
      {children}
    </span>
  );
}
